import React, { Suspense, useContext } from 'react';
import { BrowserRouter as Router, Routes, Route, Outlet, Navigate } from 'react-router-dom';
import { Layout, Spin } from 'antd';
import AuthContext from './contexts/authProvider';
import SettingContext from './contexts/settingProvider';
import Login from './pages/Login';
import Header from './components/Header';
import Sidebar from './components/SideBar';
// import Footer from './components/Footer';

const EnergyEvaluation = React.lazy(() => import('./pages/EnergyEvaluation'));
const OtherEvaluation = React.lazy(() => import('./pages/OtherEvaluation'));
const AIDPTester = React.lazy(() => import('./pages/AIDPTester'));
const NotFound = React.lazy(() => import('./pages/NotFound'));
const Settings = React.lazy(() => import('./pages/Settings'));

function NavWrapper() {
  const { user } = useContext(AuthContext);
  const { dark } = useContext(SettingContext);
  if (!user) return <Navigate to="/login" />
  
  return (
    <Layout className={`app-layout ${dark ? 'dark' : ''}`}>
      <Sidebar />
      <Layout className="app-background">
        <Header />
        <Suspense
          fallback={
            <div className="app-content loading" style={{ width: '100%' }}>
              <Spin size='large'/>
            </div>
          }
        >
          <Outlet />
        </Suspense>
        {/* <Footer /> */}
      </Layout>
    </Layout>
  );
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/" element={<NavWrapper />}>
          <Route path="/" element={<Navigate replace to="/energyevaluation" />} />
          <Route path="/energyevaluation" element={<EnergyEvaluation />} />
          <Route path="/otherevaluation" element={<OtherEvaluation />} />
          <Route path="/aidptester" element={<AIDPTester />} />
          <Route path="/settings" element={<Settings />} />
        </Route>
        <Route path="/*" element={<NotFound />} />
      </Routes>
    </Router>
  );
}

export default App;
